import { type StateCreator } from 'zustand';

import { type AppState } from './store.js';

export interface PrefsSlice {
  readonly prefs: {
    /**
     * Selected columns per resource.
     *
     * A resource absent from this map has no stored selection, which is not
     * the same as an empty selection: absent means "use the descriptor's
     * defaults", empty would mean "show nothing". Conflating them would hide
     * every column the first time someone unticked one and reloaded.
     */
    readonly columns: Readonly<Record<string, readonly string[]>>;
  };
  setColumnSelection: (resource: string, columnIds: readonly string[]) => void;
  clearColumnSelection: (resource: string) => void;
}

export const createPrefsSlice: StateCreator<AppState, [], [], PrefsSlice> = (set) => ({
  prefs: { columns: {} },

  setColumnSelection: (resource, columnIds) => {
    set((state) => ({
      prefs: { ...state.prefs, columns: { ...state.prefs.columns, [resource]: columnIds } },
    }));
  },

  clearColumnSelection: (resource) => {
    set((state) => {
      // Delete rather than set to `[]`, so the descriptor defaults apply again.
      const { [resource]: _removed, ...rest } = state.prefs.columns;
      return { prefs: { ...state.prefs, columns: rest } };
    });
  },
});
